// ⭐ Formato de dinero centralizado. `x.toFixed(2)` aparece repetido más de
// 130 veces en pos/ (Caja, Mesas, Pedidos, Reportes, Productos, Recibo,
// Cierre de Caja, Auditoria, Menu Publico) -- siempre con el mismo patrón
// exacto, así que no era código divergiendo entre archivos como pasaba con
// CustomAlert o el timezone, sino simplemente falta de un solo lugar para:
//
// 1. Blindar contra NaN: hoy, si algún cálculo produce NaN (ej. un campo
//    vacío parseado con parseFloat), `NaN.toFixed(2)` imprime literalmente
//    "$NaN" en pantalla -- un detalle poco profesional que un cliente
//    real puede llegar a ver. formatMoney nunca devuelve eso.
// 2. Tener un solo lugar para cambiar el formato de dinero a futuro
//    (separador de miles, símbolo de moneda, etc.) sin tocar 130+ sitios.
//
// Uso: reemplaza `algo.toFixed(2)` por `formatMoney(algo)` en código NUEVO
// o al tocar una función existente por otro motivo. No se migraron los
// 130+ usos existentes de una sola vez: son literalmente `.toFixed(2)`
// sin lógica propia, así que no había una divergencia real que corregir,
// y una migración mecánica masiva en un sistema en producción con clientes
// reales no vale el riesgo de una edición mal hecha en un monto de dinero.
export function formatMoney(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n.toFixed(2) : '0.00';
}
